module.exports = __webpack_public_path__ + "static/img/icon14.31f64a0c.png";